


















































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    recibo: {},
    disabled: Boolean,
  },
  data: () => ({
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    openDialog: false,
    finishDialog: false,
    headers: [
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Concepto', value: 'concepto.nombre' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Precio unitario', value: 'unitario' },
      { text: 'Importe', value: 'importe' },
    ],
    items: [
    ],
    Formatos: [
      {
        name: 'Aviso',
        value: 'aviso',
      },
      {
        name: 'Recibo',
        value: 'recibo',
      },
    ],
    formato: {},
    nuevoItem: {
      cantidad: '',
      concepto: {},
      descripcion: '',
      unidadDeMedida: '',
      unitario: '',
      importe: 0,
    },
    Recibo: '',
    loading: false,
    result: {},
    var: 0,
    unidades: [],
    conceptos: [],
    unidadSeleccionada: {},
    conceptoSeleccionado: {},
    propietarioSeleccionado: {},
    asociar: false,
    propietarios: [],
    total: 0,
    isFormatoEmpty: true,
    botonActivo: true,
    mensaje: '',
  }),
  computed: {
  },
  methods: {
    async loadData() {
      // console.log('Recibos: %o', this.recibo);
      if (this.formato.value === 'recibo') {
        this.mensaje = 'Imprimir Recibos';
        try {
          // console.log('Recibo Solo');
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const recibo = this.recibo;
          // console.log('this.recibo: %o', this.recibo);
          this.loading = true;
          const result = await this.$store.dispatch('generarRecibo', {admin, condo, recibo});
          this.Recibo = result;
          // console.debug('generarRecibo result: %o', result);
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      } else if (this.formato.value === 'aviso') {
        this.mensaje = 'Imprimir Avisos';
        try {
          // console.log('Recibo Solo');
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const recibo = this.recibo;
          // console.log('this.recibo: %o', this.recibo);
          this.loading = true;
          const result = await this.$store.dispatch('generarAviso', {admin, condo, recibo});
          this.Recibo = result;
          // console.debug('generarRecibo result: %o', result);
        } catch (e) {
          // this.$toast.error(e);
          this.$toast.error(e.response.data.message);
          this.botonActivo = false;
        }
      } else {
        this.$toast.error('Seleccione un formato válido');
      }
      this.loading = false;
    },
    printData() {
      this.$htmlToPaper('reciboImprimir');
    },
    changeFormat() {
      if (this.formato.nombre !== '' && this.formato.value !== '') {
        this.finishDialog = true;
        this.openDialog = false;
      } else {
        this.$toast.error('Seleccione un formato');
      }
    },
  },
  watch: {
    openDialog() {
      if (this.finishDialog) {
        this.loadData();
      }
      if (this.openDialog) {
        this.botonActivo = true;
        this.formato = {nombre: '', value: ''};
        this.Recibo = '';
      }
    },
    formato() {
      if (Object.keys(this.formato).length === 0 || this.formato.nombre === '' || this.formato.value === '') {
        this.isFormatoEmpty = true;
      } else {
        this.isFormatoEmpty = false;
      }
    },
  },
});
